export const FEATURES_HEADER = {
  eyebrow: 'The Vesna Difference',
  headline: 'A new way of listening to your body. Built for your biology, not around it.',
};

// `overlay` keys map to the overlay component each FeatureCard renders —
// see FeatureCardDesktop.js / FeatureCardMobile.js for the switch.
export const FEATURE_CARDS = [
  {
    number: '01',
    title: 'A beautiful tracker',
    description:
      'The building blocks of a successful GLP-1 journey: track your nutrition, movement, sleep, stress, and GLP-1 medication all in one holistic view.',
    image: '/landing-assets/feature-tracker.jpg',
    tint: 0,
    overlay: 'protocols',
  },
  {
    number: '02',
    title: 'Trained on female biology',
    description:
      'Energy, hormones, sleep, strain — your physiology moves in cycles a generic tracker was never built to see. With Vesna, your hormone health remains central to the guidance you receive, factored in from the very start.',
    image: '/landing-assets/feature-biology.jpg',
    tint: 0.14,
    overlay: 'healthProfile',
  },
  {
    number: '03',
    title: 'Symptom patterns',
    description: 'Energy crashes, cravings, GI discomfort — Vesna deciphers the patterns in how your body responds, day to day.',
    image: '/landing-assets/feature-symptoms.jpg',
    tint: 0,
    overlay: 'signalGrid',
  },
  {
    number: '04',
    title: 'Weekly weight insights',
    description:
      "Interpret your weight with full context — injection cycle, body signals, your sleep and stress patterns — so you understand what's actually happening in your body, not just what the scale says.",
    image: '/landing-assets/feature-weight.jpg',
    tint: 0.22,
    overlay: 'weight',
  },
];
